import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { LorenLayer } from "../../../../services/loren-layer-service/interfaces/loren-layer.interface";
import { environment } from "../../../../../../environments/environment";

@Component({
    selector: "loren-layer-selection",
    templateUrl: "./loren-layer-selection.component.html",
    styleUrls: ["./loren-layer-selection.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenLayerSelectionComponent {
  @Input() allMapLayers: LorenLayer[] = [];
  @Input() lastSelectedLayers: LorenLayer[] = [];
  @Input() btnLook = "layer-selection-btn";
  @Input() buttonBottomOffset: number;
  @Output() finishLayerSelection = new EventEmitter<LorenLayer[]>();
  @Output() cancelLayerSelection = new EventEmitter<Event>();

  showLayerSelectionDialog: boolean;
  tenant = environment.tenant;
}
